import { render } from "./Service3.vue?vue&type=template&id=0bf3b5d2"
import script from "./Service3.vue?vue&type=script&lang=js"
export * from "./Service3.vue?vue&type=script&lang=js"
script.render = render

export default script